export default "__VITE_ASSET__Dr$iQoXD__"